export default "__VITE_ASSET__8a9784db__"